var _style, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "180 55 240 350",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E3239;}\n\t.st1{fill:#1B8FCF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 105,
    width: 260,
    height: 260,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.3,135c-10.7,0-19.5-8.8-19.5-19.5V91c0-10.7,8.8-19.5,19.5-19.5c10.7,0,19.5,8.8,19.5,19.5v4.9h53.7 c4.4,0,7.3,2.9,7.3,7.3s-2.9,7.3-7.3,7.3h-61.1c-4.4,0-7.3-2.9-7.3-7.3V91c0-2.9-2-4.9-4.9-4.9c-2.9,0-4.9,2-4.9,4.9v24.4 c0,2.9,2,4.9,4.9,4.9c4.4,0,7.3,2.9,7.3,7.3C258.6,132.1,255.7,135,251.3,135z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410,379.2H190.2c-17.6,0-31.8-14.2-31.8-31.8V127.7c0-17.6,14.2-31.8,31.8-31.8h24.4c4.4,0,7.3,2.9,7.3,7.3 s-2.9,7.3-7.3,7.3h-24.4c-9.3,0-17.1,7.8-17.1,17.1v219.8c0,9.3,7.8,17.1,17.1,17.1H410c9.3,0,17.1-7.8,17.1-17.1V127.7 c0-9.3-7.8-17.1-17.1-17.1h-36.6c-4.4,0-7.3-2.9-7.3-7.3V91c0-2.9-2-4.9-4.9-4.9s-4.9,2-4.9,4.9v24.4c0,2.9,2,4.9,4.9,4.9 c4.4,0,7.3,2.9,7.3,7.3c0,4.4-2.9,7.3-7.3,7.3c-10.7,0-19.5-8.8-19.5-19.5V91c0-10.7,8.8-19.5,19.5-19.5s19.5,8.8,19.5,19.5v4.9H410 c17.6,0,31.8,14.2,31.8,31.8v219.8C441.8,365.1,427.6,379.2,410,379.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.4,159.4H226.9c-3.9,0-7.3,3.4-7.3,7.3v146.5c0,3.9,3.4,7.3,7.3,7.3h146.5c3.9,0,7.3-3.4,7.3-7.3V166.8 C380.7,162.8,377.3,159.4,373.4,159.4z M283,222.9h34.2v34.2H283V222.9z M268.4,257.1h-34.2v-34.2h34.2V257.1z M331.9,222.9h34.2 v34.2h-34.2V222.9z M331.9,208.3v-34.2h34.2v34.2H331.9z M317.2,208.3H283v-34.2h34.2V208.3z M268.4,208.3h-34.2v-34.2h34.2V208.3z  M234.2,271.8h34.2V306h-34.2V271.8z M283,271.8h34.2V306H283V271.8z M331.9,271.8h34.2V306h-34.2V271.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateFilterIcon);
export default __webpack_public_path__ + "static/media/date_filter_icon.9e8568a0a4c684c56f4dc1a7040a75c8.svg";
export { ForwardRef as ReactComponent };